import { render, staticRenderFns } from "./UkrposhtaTableMobile.vue?vue&type=template&id=3245f49c&scoped=true"
import script from "./UkrposhtaTableMobile.vue?vue&type=script&lang=js"
export * from "./UkrposhtaTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245f49c",
  null
  
)

export default component.exports